"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = addUser;
exports.changeTenant = changeTenant;
exports.changeToken = changeToken;
exports.changeUserStatus = changeUserStatus;
exports.delUser = delUser;
exports.deptTreeSelect = deptTreeSelect;
exports.exportUser = exportUser;
exports.firstReset = firstReset;
exports.getUser = getUser;
exports.getUserProfile = getUserProfile;
exports.importTemplate = importTemplate;
exports.isAdmin = isAdmin;
exports.listUser = listUser;
exports.resetUserPwd = resetUserPwd;
exports.sendToSso = sendToSso;
exports.updateUser = updateUser;
exports.updateUserProfile = updateUserProfile;
exports.updateUserPwd = updateUserPwd;
exports.uploadAvatar = uploadAvatar;
var _request = _interopRequireDefault(require("@/utils/request"));
var _utils = require("@/utils/utils");
var _cloud = require("@/utils/cloud");
// 查询用户列表
function listUser(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/list',
    method: 'get',
    params: query
  });
}

// 查询用户详细
function getUser(userId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/' + (0, _utils.praseStrEmpty)(userId),
    method: 'get'
  });
}

// 新增用户
function addUser(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user',
    method: 'post',
    data: data
  });
}

// 修改用户
function updateUser(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user',
    method: 'put',
    data: data
  });
}

// 切换组织
function changeTenant(tenantId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/changeTenant/' + tenantId,
    method: 'put'
  });
}

// 是否管理员
function isAdmin() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/isAdmin',
    method: 'get'
  });
}

// 删除用户
function delUser(userId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/' + userId,
    method: 'delete'
  });
}

// 导出用户
function exportUser(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/export',
    method: 'get',
    params: query
  });
}

// 用户密码重置
function resetUserPwd(userId, password) {
  var data = {
    userId: userId,
    password: password
  };
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/resetPwd',
    method: 'put',
    data: data
  });
}

//首次登录密码重置
function firstReset(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/firstPwd',
    method: 'put',
    data: data
  });
}

// 用户状态修改
function changeUserStatus(userId, status) {
  var data = {
    userId: userId,
    status: status
  };
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/changeStatus',
    method: 'put',
    data: data
  });
}

// 查询用户个人信息
function getUserProfile() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/profile',
    method: 'get'
  });
}

// 修改用户个人信息
function updateUserProfile(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/profile',
    method: 'put',
    data: data
  });
}

// 用户密码重置
function updateUserPwd(oldPassword, newPassword) {
  var data = {
    oldPassword: oldPassword,
    newPassword: newPassword
  };
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  });
}

// 用户头像上传
function uploadAvatar(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/profile/avatar',
    method: 'post',
    data: data
  });
}

// 下载用户导入模板
function importTemplate() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/importTemplate',
    method: 'get'
  });
}

// 切换登录信息
function changeToken(tenantId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/changeToken/' + tenantId,
    method: 'get'
  });
}

// 查询部门下拉树结构
function deptTreeSelect() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/deptTree',
    method: 'get'
  });
}

// 同步用户信息到sso
function sendToSso(userId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/user/sendToSso/' + userId,
    method: 'post'
  });
}